<template>
  <main class="app-get-step" id="mainContent">
    <div class="app-main-content" v-if="$store.state.guestLogin.cancelRegistration && $store.state.guestLogin.cancelRegistration.descriptions==''">
      <h1>{{ screenData.title }}</h1>
      <p class="cancel-reg">ALL REGISTRATION CANCELLATIONS ARE FINAL.</p>

      <div class="app-content-panels">
        <form class="app-panel-left">
          <p><strong>To process your cancel registration request, you will need:</strong></p>
          <ul class="renew-ready">
            <li>
              <p> - A <b>valid email address</b> where you will receive a acknowledgement of your cancellation of registration.</p>
            </li>
          </ul>
          <BaseButtonGroup>
            <!-- <button type="button" @click="handleRouting(true)">Previous</button>
            <button type="button" class="app-btn-primary" @click="handleRouting(false)">Next</button>
            <button type="button" v-if="!disableBtn" @click="handleRouting(true)"> Cancel and go to profile </button>
            <button type="button" :class="{ 'disabled': !disableBtn }" :aria-disabled="!disableBtn"
              @click="goToTxnCart(true)" v-if="disableBtn"> Cancel and go to cart 
            </button> -->

            <CustomButton @click="handleRouting(true)" class="resend-code">Previous</CustomButton>
            <CustomButton @click="handleRouting(false)">Next</CustomButton>
            <CustomButton v-if="!disableBtn" @click="handleRouting(true)" class="resend-code"> Cancel and go to profile </CustomButton>
            <CustomButton :class="{ 'disabled': !disableBtn }" :aria-disabled="!disableBtn" class="resend-code"
              @click="goToTxnCart(true)" v-if="disableBtn"> Cancel and go to cart
            </CustomButton>
          </BaseButtonGroup>
        </form>
      </div>
    </div>
    <div class="app-main-content" v-if="$store.state.guestLogin.cancelRegistration && $store.state.guestLogin.cancelRegistration.descriptions!=''">
      <div class="app-alert-error">
        <ul class="err-codes">
          <li v-for="(description, i) in $store.state.guestLogin.cancelRegistration.descriptions" :key="i">
            <p> {{ description }} </p>
            <p class="sr-only">{{ description }}</p>
          </li>
        </ul>             
      </div>
      <BaseButtonGroup>
        <!-- <button type="button" @click="handleRouting(true)">Previous</button>  
        <button type="button" class="app-btn-primary" :class="{ 'disabled': !disableBtn }" :aria-disabled="!disableBtn"
          @click="goToTxnCart(true)" v-if="$store.state.guestLogin.cartTransactions && $store.state.guestLogin.cartTransactions.cartTransactions.length > 0">
           Cancel and go to cart
        </button>
        <button type="button" class="app-btn-primary" @click="handleRouting(true)" v-else>
           Cancel and go to profile
        </button> -->

        <CustomButton @click="handleRouting(true)" class="reg-previous">Previous</CustomButton>
        <CustomButton :class="{ 'disabled': !disableBtn }" :aria-disabled="!disableBtn"
          @click="goToTxnCart(true)" v-if="$store.state.guestLogin.cartTransactions && $store.state.guestLogin.cartTransactions.cartTransactions.length > 0">
          Cancel and go to cart 
        </CustomButton>
        <CustomButton @click="handleRouting(true)" v-else> Cancel and go to profile </CustomButton>
      </BaseButtonGroup>
    </div>
  </main>
</template>
    
<script>
  import appConfig from '@/app.config';
  import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
  import { mapState, mapActions, mapGetters } from 'vuex';
  import * as COMMONS from '../../store/_commons';
  import CustomButton from '../../components/CustomButton.vue';
  
  export default {
    name: 'GetReady',
    page: {
      title: `Get Ready | ${appConfig.shortName}`,
      meta: [
        {
          name: 'description',
          content: 'First step (Get Ready) for cancelling your registration'
        }
      ]
    },
    data() {
      return {
        stepNum: 1,
        screenData: {},
        enableNext: true,
      }
    },
    components: {
      BaseButtonGroup,
      CustomButton
    },
    computed: {
      ...mapGetters({
        // statusInfo: COMMONS.GUEST_LOGIN_STATUS_INFO,
        // personalInfo: COMMONS.GUEST_PERSONAL_INFO,
        // transactionInfo: COMMONS.GUEST_CREATE_TRANSACTION_INFO  
      }),

      ...mapState([
        'LANG',
        'STEPS',
      ]),
      
      language() {
        return this.LANG;
      },

      disableBtn() {
        let btn = false;
        if(this.$store.state.guestLogin.cartTransactions) {
          btn = this.$store.state.guestLogin.cartTransactions.cartTransactions.length > 0
        }
        return btn;
      }
    },

    created() { 
      document.body.setAttribute("tabindex", "1");
      document.body.focus();
      document.body.removeAttribute("tabindex");
    },

    methods: {
      ...mapActions({
        getCreateTransactionService: COMMONS.GUEST_CREATETRANSACTION,
        getRemoveTransaction: COMMONS.GUEST_REMOVETRANSACTION,
        getAddTransaction: COMMONS.GUEST_ADDTRANSACTION,
        getRenewPreviousStep: COMMONS.GUEST_RENEWPREVIOUSSTEP
      }),

      handleRouting(isPrev = false) {
        if (isPrev) {
          this.$router.push({ name:  'Profile' });
        } 
        else {
          if (this.$store.state.guestLogin.cartTransactions && this.$store.state.guestLogin.cartTransactions.cartTransactions.length > 0) {
            this.getAddTransaction();
          } else {
              this.getCreateTransactionService();
            }
          this.$emit('getStep' , 2)
        }
      },


      goToTxnCart() {
        this.$store.state.guestLogin.step = 4;
        this.$emit('getStep' , 4)
      },
    },

    mounted() {
      window.scroll(0,0);
      this.screenData = this.STEPS[this.stepNum];
      document.getElementById("mainContent").focus();
    }
  }
</script>

<style scoped lang="scss">
  .app-alert-error {
    display: block;
    margin-top: 20px;
    margin-bottom: 2rem;
    font-size: 18px;
    line-height: 28px;
    padding-left: 1rem;
    padding-right: 10px;
    ul {
      padding: 10px;
    }
  }
  .app-content-panels {
    margin-top: 1rem;
    .resend-code{
      background-color: white;
      color: var(--ri-blue);

      &:hover{
        background-color: var(--ri-lighter-blue);
        color: var(--ri-darker-blue);
      }
    }
  }
  .renew-ready {
    margin-bottom: 2rem;
  }
  .app-button-group {
    margin-top: 1rem;
  }
  .err-codes {
    list-style: initial;
    margin-left: 1rem;
  }

  .cancel-reg{
    color: black;
    font-size: 18px;
    font-weight: 600;
  }
  .reg-previous{
    background-color: white;
    color: var(--ri-blue);

    &:hover{
      background-color: var(--ri-lighter-blue);
      color: var(--ri-darker-blue);
    }
  }
</style>
